var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPiChartSales(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5627 0.143618C6.57889 1.93903 -2.73304 15.6016 0.723155 29.253C3.03858 38.3988 10.7098 45.3519 20.0231 46.7463C26.7368 47.7515 33.7507 45.7339 38.8301 41.3362L39.1515 41.0578L30.7305 32.6272C25.9889 27.8801 22.2676 24.0835 22.2135 23.938C22.1486 23.7631 22.1175 19.8499 22.1175 11.8398V0L21.8191 0.0102847C21.655 0.015978 21.0896 0.076033 20.5627 0.143618ZM24.8724 11.0652V22.1304H35.9376C44.7573 22.1304 47.0028 22.107 47.0028 22.015C47.0028 21.9516 46.9414 21.3754 46.8665 20.7346C45.6781 10.5758 37.8819 2.22461 27.8568 0.371625C26.9316 0.200551 25.4239 0.00257116 25.0331 0.000734618C24.8809 0 24.8724 0.587878 24.8724 11.0652ZM33.9635 32.0053L41.0799 39.1254L41.341 38.8235C44.5101 35.1601 46.4651 30.5232 46.9567 25.505L47.0173 24.8852H36.9322H26.8471L33.9635 32.0053Z",
    fill: "#7DA4B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiChartSales);
export default __webpack_public_path__ + "static/media/pi-chart-sales.d735886a5ae4b651f8b2aa0172ad289e.svg";
export { ForwardRef as ReactComponent };